export const FLAG_NUMBER_ENUM = {
  TRUE: {
    value: 1,
    desc: '是'
  },
  FALSE: {
    value: 0,
    desc: '否'
  }
};


export default {
  FLAG_NUMBER_ENUM
};
